// SBU and Track mapping from Excel file
export const GROUP_MAPPING = {
  "SN BusService Oracle ASCP Monitoring": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle EDI Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle INV Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle Logistics Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle MFG Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle OM Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle OTC Functional": { sbu: "Enterprise Apps", track: "R12 Finance" },
  "SN BusService Oracle PO Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN BusService Oracle PTP Functional": { sbu: "Enterprise Apps", track: "R12 Finance" },
  "SN BUSSERVICE ORACLE RTR Functional": { sbu: "Enterprise Apps", track: "R12 Finance" },
  "SN BusService Oracle SVC Functional": { sbu: "Enterprise Apps", track: "R12 ISC" },
  "SN-GBL-Tier 2-EXApps ESC (My HR Support)": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Comp (PeopleFluent)": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Hire (Taleo)": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Legal Workcenter": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps PeopleSoft": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps Talent Mgmt Sys (TMS)": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps TeamConnect": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support promotion claim Center": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support BOM Lookup": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support FRACAS Support": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support IT HVAC Parts and Supply Solutions": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support NA Maxload": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support P21 Technical": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support PBS Deployment": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN APPl Support RS BP Apps": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support RS eBiz Apps": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support RS IT Warehouse Applications": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support RS Mendix": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support Ansira Co-Op Program": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support RS MES Applications": { sbu: "Enterprise Apps", track: "MES" },
  "SN Appl Support RS Sales and Margin Warehouse (SMW)": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support RS UPDS Order Fulfilment Team": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support SPIM DB": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support iService Access": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support MENDIX TRANSPORT AMERICAS": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support Test Request Process": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support TK iServiceDP Apps": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support L1.5 Smart ops Team": { sbu: "Enterprise Apps", track: "Tools" },
  "SN Appl Support HP Quality Center": { sbu: "Enterprise Apps", track: "Tools" },
  "SN Appl Support DFSD ANZ": { sbu: "Enterprise Apps", track: "MES" },
  "SN Appl Support Ent Apps Mendix": { sbu: "Enterprise Apps", track: "Customer Experience (CX)" },
  "SN-GBL-Tier 3-EXApps PeopleSoft": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps DSD Reporting": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps PhenomCRM Support": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support AWS Middleware Operations": { sbu: "Enterprise Apps", track: "Integration & Middleware" },
  "SN Appl Support Apriso RSHVAC": { sbu: "Enterprise Apps", track: "RES" },
  "SN Appl Support Dist Trailor Tracking Mendix": { sbu: "Enterprise Apps", track: "Customer Experience (CX)" },
  "SN-GBL-Tier 3-EXApps UKG Dimensions": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps UKG Dimensions": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support Gigaton Analytics": { sbu: "Enterprise Apps", track: "Data & Analytics" },
  "SN Appl Support RADAR Product Team": { sbu: "Enterprise Apps", track: "Data & Analytics" },
  "SN Appl Support Tableau License": { sbu: "Enterprise Apps", track: "Data & Analytics" },
  "SN Appl Support Alteryx License": { sbu: "Enterprise Apps", track: "Data & Analytics" },
  "SN Appl Support LATAM JOB SCORING": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support Lotus Notes": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support Service Agreement Renewal Task Board": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 3-EXApps PS HRMS Integrations": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 3-EXApps TCC_Taleo": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support India HR Application": { sbu: "Enterprise Apps", track: "Employee Experience (EX)" },
  "SN Appl Support Controls Self-Assessment (CSA) Tool": { sbu: "Enterprise Apps", track: "L1.5" },
  "SN Appl Support Ultriva": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support Demantra": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support EOT Service": { sbu: "Enterprise Apps", track: "CHVAC Americas" },
  "SN Appl Support Intl Sales Tools Spectrum": { sbu: "Enterprise Apps", track: "CHVAC Americas" },
  "SN Appl Support VO": { sbu: "Enterprise Apps", track: "CHVAC Americas" },
  "SN Appl Support CS Field Service Tools Support": { sbu: "Enterprise Apps", track: "CHVAC Americas" },
  "SN Appl Support CRM Development": { sbu: "Enterprise Apps", track: "Customer Experience (CX)" },
  "SN Appl Support ProdAndTechSuptContactForm": { sbu: "Enterprise Apps", track: "CHVAC Americas" },
  "SN Appl Support EDH": { sbu: "Enterprise Apps", track: "Data & Analytics" },
  "SN-GBL-Tier 2-EXApps India E-Apps": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support P21 Mexico": { sbu: "Enterprise Apps", track: "RES, TK" },
  "SN Appl Support Evolven": { sbu: "Infrastructure", track: "Tools" },
  "SN Wipro Service Desk RDS": { sbu: "Infrastructure", track: "Service Desk" },
  "SN IT Security Firewall": { sbu: "Infrastructure", track: "Security" },
  "SN Knowledge Admin": { sbu: "Infrastructure", track: "ITSM" },
  "SN Appl Support Access Security": { sbu: "Infrastructure", track: "Security" },
  "SN Orion SolarWinds Monitoring": { sbu: "Infrastructure", track: "Hosting" },
  "SN Wipro Service Desk Service Not Listed": { sbu: "Infrastructure", track: "Service Desk" },
  "SN Appl Support Windows 365 (Windows App) Group": { sbu: "Infrastructure", track: "EUC" },
  "SN Appl Support Tanium": { sbu: "Infrastructure", track: "wintel" },
  "SN DBA-UNKNOWN": { sbu: "Infrastructure", track: "Database" },
  "SN Network Global Voice": { sbu: "Infrastructure", track: "NW Voice" },
  "SN BusService Support Teams Phone Service": { sbu: "Infrastructure", track: "NW Voice" },
  "SN Appl Support Company Portal": { sbu: "Infrastructure", track: "EUC" }
};

// Helper function to get mapping for a group
export const getGroupMapping = (groupName) => {
  return GROUP_MAPPING[groupName] || { sbu: "Unknown", track: "Unknown" };
};

// Get all unique SBUs
export const getAllSBUs = () => {
  const sbus = [...new Set(Object.values(GROUP_MAPPING).map(m => m.sbu))];
  return sbus.sort();
};

// Get all unique Tracks
export const getAllTracks = () => {
  const tracks = [...new Set(Object.values(GROUP_MAPPING).map(m => m.track))];
  return tracks.sort();
};

// Get tracks for a specific SBU
export const getTracksForSBU = (sbu) => {
  const tracks = Object.values(GROUP_MAPPING)
    .filter(m => m.sbu === sbu)
    .map(m => m.track);
  return [...new Set(tracks)].sort();
};

// Get assignment groups for a specific track
export const getGroupsForTrack = (track) => {
  return Object.entries(GROUP_MAPPING)
    .filter(([_, mapping]) => mapping.track === track)
    .map(([groupName, _]) => groupName);
};

// Get assignment groups for a specific SBU
export const getGroupsForSBU = (sbu) => {
  return Object.entries(GROUP_MAPPING)
    .filter(([_, mapping]) => mapping.sbu === sbu)
    .map(([groupName, _]) => groupName);
};
